import { Attrs, MinzeElement } from 'minze'

export interface LvcCircleCheckSelectIcon {}

export class LvcCircleCheckSelectIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 29],
    ['height', 28],
  ]
  html = () => `
    <svg width="${this.width}" height="${this.height}" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="28" height="28" rx="14" fill="#1E007D"/>
    <path d="M20.1004 10C17.63 12.4261 15.1754 15.1299 12.848 17.7112C12.703 17.872 12.4562 17.8882 12.2915 17.7475C10.9761 16.6238 10.0183 15.7663 8.90039 14.3512" stroke="#FF4600" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
